export const colors = [
  "#7b2cbf",
  "#168aad",
  "#16db93",
  "#83e377",
  "#b9e769",
  "#efea5a",
  "#f1c453",
  "#f29e4c",
  "#f95738",
];
